<template>
  <div>
    <form>
      <!-- begin invoice -->
      <div class="invoice">
        <!-- begin invoice-header -->
        <div class="invoice-header">
          <div class="invoice-from">
            <small>{{ $t('restaurantSale.orderInfo') }}</small>
            <address class="m-t-5 m-b-5">
              <strong class="text-inverse"
                >{{ $t('restaurantSale.order') }}: #{{
                  tableSelected.order_no
                }}</strong
              ><br />
              {{ $t('restaurantSale.status') }}:
              {{ tableSelected.invoice_status }}<br />
              Fx: {{ defaultCrrency }} 1 = {{ toCurrency }} {{ exchangeRate }}
            </address>
          </div>
          <div class="invoice-to">
            <small>{{ $t('restaurantSale.tableInfo') }}</small>
            <address class="m-t-5 m-b-5">
              <strong class="text-inverse"
                >{{ $t('restaurantSale.table') }}:
                {{ tableSelected.table_no }}</strong
              ><br />
              {{ $t('restaurantSale.status') }}: {{ tableSelected.status_name
              }}<br />
              {{ $t('restaurantSale.numberOfCustomer') }}:
              {{ tableSelected.num_customer_status }}<br />
            </address>
          </div>
          <div class="invoice-date">
            <small>{{ $t('restaurantSale.dateAndTime') }}</small>
            <div class="date text-inverse m-t-5">
              {{ currentDate }}
            </div>
            <div class="invoice-detail">
              {{ $t('restaurantSale.startTime') }}:
              {{ tableSelected.start_time }} <br />
              {{ $t('restaurantSale.now') }}: {{ time }}
            </div>
          </div>
        </div>
        <!-- end invoice-header -->
        <!-- begin invoice-content -->
        <div class="invoice-content">
          <!-- begin invoice-price -->
          <div class="invoice-price">
            <div class="invoice-price-left">
              <div class="invoice-price-row" style="width: 100%">
                <div class="sub-price" style="width: 30%;margin-top: -8px;">
                  <small>{{ $t('restaurantSale.subtotal') }}</small>
                  <span class="text-inverse"
                    >{{ defaultCrrency }}
                    {{ tableSelected.sub_total | format_number }}</span
                  >
                </div>
                <div class="sub-price text-center" style="width: 170px">
                  <small>{{ $t('restaurantSale.discount') }}</small>
                  <b-input-group size="sm">
                    <b-input-group-prepend is-text>
                      <input
                        type="radio"
                        v-model="model.discount_type"
                        id="dolar"
                        :value="'$'"
                      />
                      &nbsp;$
                    </b-input-group-prepend>
                    <b-form-input
                      v-model.number="model.discount_rate"
                      class="text-center"
                      @input="calculate"
                    ></b-form-input>
                    <b-input-group-prepend is-text for="percentage">
                      <input
                        type="radio"
                        v-model="model.discount_type"
                        id="percentage"
                        :value="'%'"
                      />
                      &nbsp;%
                    </b-input-group-prepend>
                  </b-input-group>
                </div>
                <div
                  class="sub-price text-right"
                  style="width: 35%; margin-top: -8px;"
                >
                  <small
                    >{{ $t('restaurantSale.vat') }}
                    {{ vatRate ? '(' + vatRate + '%)' : '' }}</small
                  >
                  <span class="text-inverse">
                    {{ defaultCrrency }}
                    {{ model.vat_amount | format_number }}</span
                  >
                </div>
              </div>
            </div>
            <div class="invoice-price-right" style="background: #808B96;">
              <small>{{ $t('restaurantSale.total') }}</small>
              <span class="f-w-600"
                >{{ defaultCrrency }}
                {{ model.grand_total | format_number }}</span
              >
            </div>
          </div>
          <br />
          <div class="payment">
            <label class="col-form-label">
              {{ $t('restaurantSale.cashPayment') }}</label
            >
            <div class="invoice-price">
              <div class="invoice-price-left">
                <div class="form__group field">
                  <input
                    ref="paid_in_default_currency"
                    type="number"
                    class="form__field"
                    :placeholder="
                      $t('restaurantSale.cashPayment') + defaultCrrency
                    "
                    v-model.number="paid_in_default_currency"
                    min="0"
                    @input="calculate"
                    required
                  />
                  <label for="name" class="form__label">
                    {{ $t('restaurantSale.cashIn') }}
                    {{ defaultCrrency }}</label
                  >
                </div>
              </div>
              <div class="invoice-price-right">
                <span
                  class="f-w-600 text-success"
                  :class="{ 'text-danger': change_in_default_currency < 0 }"
                  >{{ defaultCrrency }}
                  {{ change_in_default_currency | format_number }}</span
                >
              </div>
            </div>
            <div class="invoice-price">
              <div class="invoice-price-left">
                <div class="form__group field">
                  <input
                    type="number"
                    class="form__field"
                    :placeholder="$t('restaurantSale.cashPayment') + toCurrency"
                    v-model.number="paid_in_to_currency"
                    min="0"
                    @input="calculate"
                    required
                  />
                  <label for="name" class="form__label">
                    {{ $t('restaurantSale.cashIn') }} {{ toCurrency }}</label
                  >
                </div>
              </div>
              <div class="invoice-price-right">
                <span
                  class="f-w-600 text-success"
                  :class="{ 'text-danger': change_in_to_currency < 0 }"
                  >{{ toCurrency }}
                  {{ change_in_to_currency | format_number }}</span
                >
              </div>
            </div>
            <div class="form-group row">
              <label class="col-md-2 col-form-label"
                >+ {{ $t('restaurantSale.otherPayment') }}</label
              >
              <div class="col-md-5">
                <ul class="list-inline payment-type">
                  <li :class="{ active: isActive == 'coupon' }">
                    <a
                      href="#"
                      :title="$t('restaurantSale.coupon')"
                      @click="
                        ;[
                          (isActive = 'coupon'),
                          (model.paid_in_credit_card = null)
                        ]
                      "
                      ><i class="fab fa-contao"></i
                    ></a>
                  </li>
                  <li :class="{ active: isActive == 'credit_card' }">
                    <a
                      href="#"
                      :title="$t('restaurantSale.creditCard')"
                      @click="
                        ;[
                          (isActive = 'credit_card'),
                          (model.paid_in_coupon = null)
                        ]
                      "
                      ><i class="far fa-credit-card"></i
                    ></a>
                  </li>
                </ul>
                <input
                  v-if="isActive == 'coupon'"
                  type="nomber"
                  v-model.number="model.paid_in_coupon"
                  class="form-control"
                  :placeholder="$t('restaurantSale.couponInUsd')"
                  @input="calculate"
                  min="0"
                />
                <input
                  v-if="isActive == 'credit_card'"
                  type="nomber"
                  v-model.number="model.paid_in_credit_card"
                  class="form-control"
                  :placeholder="$t('restaurantSale.creditCardInUsd')"
                  min="0"
                  @input="calculate"
                />
              </div>
              <div class="col-md-5 mt-1" style="margin-left: -4px;">
                <a-alert
                  v-if="
                    errors.has('change_in_usd') || errors.has('change_in_riel')
                  "
                  message="Payment"
                  :description="
                    errors.first('change_in_usd')
                      ? errors.first('change_in_usd')
                      : errors.first('change_in_riel')
                  "
                  type="error"
                  show-icon
                  closable
                />
              </div>
            </div>
          </div>
        </div>
        <!-- end invoice-content -->
      </div>
      <!-- end invoice -->
      <!-- begin invoice-footer -->
      <div class="invoice-footer">
        <div class="row">
          <div class="col-lg-6">
            <div style="padding-left:20px">
              <ts-checkbox v-model="model.is_city_ledger">{{
                $t('restaurantSale.cityLedger')
              }}</ts-checkbox>
              <ts-checkbox v-model="model.is_clear_table">{{
                $t('restaurantSale.isCleanFromTable')
              }}</ts-checkbox>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="btn-row pull-right">
              <ts-button
                class="btn btn-default"
                :disabled="waiting"
                @click="$emit('close')"
              >
                {{ $t('cancel') }}</ts-button
              >
              <ts-button
                type="submit"
                @click.prevent="bill"
                :waiting="waiting"
                class="btn btn-success btn-lg"
                ><i v-if="!waiting" class="fas fa-check fa-fw fa-lg"></i>
                {{ $t('restaurantSale.bill') }}</ts-button
              >
            </div>
          </div>
        </div>
      </div>
      <!-- end invoice-footer -->
    </form>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import Swal from 'sweetalert2'

export default {
  name: 'checkBill',
  data () {
    return {
      model: {
        stock_out_id: null,
        table_id: null,
        counter_id: null,
        paid_in_riel: null,
        paid_in_usd: null,
        paid_in_coupon: null,
        paid_in_credit_card: null,
        change_in_riel: null,
        change_in_usd: null,
        sub_total: null,
        discount_type: '%',
        discount_rate: null,
        discount_amount: null,
        total_after_discount: null,
        vat_amount: null,
        grand_total: null,
        is_clear_table: true,
        is_city_ledger: false
      },
      paid_in_default_currency: null,
      paid_in_to_currency: null,
      change_in_default_currency: 0,
      change_in_to_currency: 0,
      time: '00:00',
      waiting: false,
      isActive: 'coupon',
      errors: new Errors()
    }
  },
  created () {
    this.handleStartTime()
    this.setDataOnSelectedTable()
    this.model.counter_id = parseInt(localStorage.getItem('counterId'))
  },
  mounted () {
    this.$refs.paid_in_default_currency.focus()
  },
  filters: {
    format_number (value) {
      return `${parseFloat(value).toLocaleString()}`
    }
  },
  computed: {
    tableSelected () {
      return this.$store.state.restaurantSale.counterCheckout.tableSelected
    },
    currentDate () {
      return moment().format('dddd, MMMM Do')
    },
    vatRate () {
      return parseFloat(
        this.$store.state.restaurantSale.customerOrder.systemSettings.vat_rate
      )
    },
    exchangeRate () {
      return parseFloat(
        this.$store.state.restaurantSale.customerOrder.systemSettings.fx_rate
      )
    },
    defaultCrrency () {
      return this.$store.state.restaurantSale.customerOrder.systemSettings
        .default_currency
    },
    toCurrency () {
      if (this.defaultCrrency == 'KHR') {
        return 'USD'
      }

      return 'KHR'
    }
  },
  methods: {
    setDataOnSelectedTable () {
      if (!_.isEmpty(this.tableSelected)) {
        this.model.stock_out_id = this.tableSelected.stock_out_id
        this.model.table_id = this.tableSelected.table_id
      }
      this.calculate()
    },
    cookingStatus (cooking_status_id) {
      if (cooking_status_id == 1) {
        return 'text-info'
      }
      if (cooking_status_id == 2) {
        return 'text-primary'
      }
      if (cooking_status_id == 3) {
        return 'text-success'
      }
      return 'text-danger'
    },
    bill () {
      this.waiting = true
      this.errors = new Errors()
      this.$store
        .dispatch(
          'restaurantSale/counterCheckout/store',
          Object.assign({}, this.model, {
            counter_id: parseInt(localStorage.getItem('counterId')),
            action_type: 'check-bill'
          })
        )
        .then(response => {
          this.$emit('close')
          Swal.fire({
            title: 'CHECK BILL',
            icon: 'success',
            html:
              response.message +
              '<br /><b>' +
              this.$t('martSale.changeIn') +
              '<span class="text-success">' +
              this.defaultCrrency +
              ' ' +
              parseFloat(this.change_in_default_currency).toLocaleString() +
              '</span> => <span class="text-success">' +
              this.toCurrency +
              ' ' +
              parseFloat(this.change_in_to_currency).toLocaleString() +
              '</span></b>',
            showCloseButton: true,
            showCancelButton: false,
            focusConfirm: false
          })
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          if (!this.errors.first('change_in_usd')) {
            this.$notification['error']({
              message: 'Bill',
              description: error.message,
              placement: 'bottomRight'
            })
          }
        })
        .finally(() => {
          this.waiting = false
        })
    },
    productPhoto (item) {
      if (item.photo === null) return ''

      return `/api/files?filePath=${item.photo}`
    },
    handleCheckTime: function (i) {
      if (i < 10) {
        i = '0' + i
      }
      return i
    },
    handleStartTime: function () {
      var today = new Date()
      var h = today.getHours()
      var m = today.getMinutes()
      var a
      m = this.handleCheckTime(m)
      a = h > 11 ? ' PM' : ' AM'
      h = h > 12 ? h - 12 : h

      this.time = h + ':' + m + a
      setTimeout(() => {
        this.handleStartTime()
      }, 500)
    },
    calculate () {
      if (this.defaultCrrency == 'USD') {
        let paid_in_to_currency = 0
        let paid_in_coupon = 0
        let paid_in_credit_card = 0
        let paid_in_default_currency = 0
        let discount_rate = 0
        paid_in_to_currency = _.round(
          this.paid_in_to_currency / this.exchangeRate,
          2
        )
        paid_in_coupon = _.round(this.model.paid_in_coupon, 2)
        paid_in_credit_card = _.round(this.model.paid_in_credit_card, 2)
        paid_in_default_currency = _.round(this.paid_in_default_currency, 2)
        discount_rate = _.round(this.model.discount_rate, 2)
        this.model.sub_total = parseFloat(this.tableSelected.sub_total)
        this.model.discount_amount =
          this.model.discount_type == '$'
            ? discount_rate
            : (this.model.sub_total * discount_rate) / 100

        this.model.total_after_discount =
          this.model.sub_total - this.model.discount_amount
        this.model.vat_amount =
          (this.model.total_after_discount * this.vatRate) / 100
        this.model.grand_total =
          this.model.total_after_discount + this.model.vat_amount
        this.change_in_default_currency = _.round(
          paid_in_default_currency +
            paid_in_to_currency +
            paid_in_coupon +
            paid_in_credit_card -
            this.model.grand_total,
          2
        )
        this.change_in_to_currency = _.round(
          this.change_in_default_currency * this.exchangeRate,
          2
        )
        this.model.paid_in_usd = paid_in_default_currency
        this.model.paid_in_riel = this.paid_in_to_currency
        this.model.change_in_usd = this.change_in_default_currency
        this.model.change_in_riel = this.change_in_to_currency
      }
      if (this.defaultCrrency == 'KHR') {
        let paid_in_to_currency = 0
        let paid_in_coupon = 0
        let paid_in_credit_card = 0
        let paid_in_default_currency = 0
        let discount_rate = 0
        paid_in_to_currency = _.round(
          this.paid_in_to_currency * this.exchangeRate,
          2
        )
        paid_in_coupon = _.round(
          this.model.paid_in_coupon * this.exchangeRate,
          2
        )
        paid_in_credit_card = _.round(
          this.model.paid_in_credit_card * this.exchangeRate,
          2
        )
        paid_in_default_currency = _.round(this.paid_in_default_currency, 2)
        discount_rate = _.round(this.model.discount_rate, 2)
        this.model.sub_total = parseFloat(this.tableSelected.sub_total)
        this.model.discount_amount =
          this.model.discount_type == '$'
            ? discount_rate * this.exchangeRate
            : (this.model.sub_total * discount_rate) / 100
        this.model.total_after_discount =
          this.model.sub_total - this.model.discount_amount
        this.model.vat_amount =
          (this.model.total_after_discount * this.vatRate) / 100
        this.model.grand_total =
          this.model.total_after_discount + this.model.vat_amount
        this.change_in_default_currency = _.round(
          paid_in_default_currency +
            paid_in_to_currency +
            paid_in_coupon +
            paid_in_credit_card -
            this.model.grand_total,
          2
        )
        this.change_in_to_currency = _.round(
          this.change_in_default_currency / this.exchangeRate,
          2
        )

        this.model.paid_in_riel = paid_in_default_currency
        this.model.paid_in_usd = this.paid_in_to_currency
        this.model.change_in_riel = this.change_in_default_currency
        this.model.change_in_usd = this.change_in_to_currency
      }
    },
    setValueCash (val) {
      if (val) {
        this.paid_in_default_currency = 0
        this.paid_in_to_currency = null
        this.clear()
      } else {
        this.paid_in_default_currency = null
        this.paid_in_to_currency = null
        this.clear()
      }
    },
    clear () {
      this.model.paid_in_coupon = null
      this.model.discount_amount = null
      this.model.discount_rate = null
      this.model.paid_in_credit_card = null
      this.calculate()
    }
  },
  watch: {
    isActive: {
      handler () {
        this.calculate()
      },
      deep: true
    },
    'model.is_city_ledger': function (val) {
      this.setValueCash(val)
    },
    'model.discount_type': function (val) {
      if (val) {
        this.calculate()
      }
    }
  }
}
</script>
<style scoped>
.invoice {
  padding: 0 20px 0 20px;
}
.invoice-header {
  padding: 1px;
}
.invoice .invoice-from {
  padding: 5px 20px;
}
.invoice .invoice-to {
  padding: 2px 20px;
}
.invoice .invoice-date {
  padding: 2px 20px;
}
.invoice > div:not(.invoice-footer) {
  margin-bottom: 10px;
}
.table > thead > tr > th,
.table > tbody > tr > th,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > tbody > tr > td,
.table > tfoot > tr > td {
  padding: 3px 5px;
}
.table-responsive {
  max-height: 15vh;
  overflow-x: scroll;
  overflow-y: scroll;
}
.table > thead > tr > th {
  position: sticky;
  top: 0;
  background: rgba(230, 230, 230, 1);
  z-index: 10;
}
.invoice .invoice-price .invoice-price-left {
  padding: 2px 10px;
  font-size: 15px;
}
.invoice .invoice-price .invoice-price-right {
  padding: 10px 10px;
  font-size: 23px;
  min-width: 41%;
}
.widget-table-img {
  width: 100px;
  height: auto;
}
.payment-type {
  font-size: 2rem;
  margin: 0;
}
.payment-type > li.active a {
  color: #2d353c;
}
.payment-type > li a {
  color: #999;
}
.form-control-lg {
  background: #fffefe;
}
.payment {
  background: #f2f3f4;
  padding: 0 0 5px 5px;
}
.invoice-footer {
  padding-top: 0;
}
.btn-row .btn {
  padding: 15px 25px;
  font-size: 0.875rem;
  min-width: 100px;
  text-align: center;
  position: relative;
  border-radius: 0;
}
.invoice .invoice-price .invoice-price-left .invoice-price-row .sub-price {
  padding: 0 10px;
}
</style>
